// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function makeQueryKey(query: Record<string, any>): string {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const entries: [string, any][] = Object.entries(query);

  if (entries.length === 0) return '__empty__';

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entries.sort(([keyA]: [string, any], [keyB]: [string, any]) => keyA.localeCompare(keyB));

  return entries.map(([k, v]) => `${k}=${v}`).join('&');
}
